import { StyleFunctionProps, mode } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Pagination: ComponentStyleConfig = {
  parts: ['Container', 'PaginationSelect'],
  baseStyle: (props: StyleFunctionProps) => {
    return {
      Container: { width: 'full' },
      PaginationSelect: {
        h: 8,
        borderRadius: 0,
        borderColor: mode('gray.300', 'gray.100')(props),
        _focus: { boxShadow: 'unset' },
        display: 'inline-block',
        w: 'auto',
      },
    };
  },
};

export default Pagination;
